import { ofType } from 'redux-observable';
import { combineLatest } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { EpicWithThunk } from 'state/state.common';
import { workspaceTabsFetchRequested } from 'state/workspaces/workspace.actions';

export function navigateToSmartQuoteWorkspaceEpic(): EpicWithThunk {
  return action$ => {
    const navigationToSmartQuoteForm$ = action$.pipe(
      ofType('ROUTE_CHANGED'),
      filter(({ path }) => path === '/smart-quote'),
    );

    const userInfoReceived$ = action$.pipe(ofType('USER_CURRENT_RECEIVED'));

    return combineLatest([navigationToSmartQuoteForm$, userInfoReceived$]).pipe(
      take(1),
      map(() => workspaceTabsFetchRequested('smartQuote')),
    );
  };
}
